export const CRX_INSTALL_MODAL_ID = '-KXvdcCjv7CkiMVASqH7';
export const CHROME_INSTALL_MODAL_ID = '-KYGGfDfHu3Lm0BgsPE5';
export const EVENTS_EXPLORER_CRX_INSTALL_MODAL_ID =
  'e83874bb-f9a1-4c63-9a48-4aa82d907f9a';
